// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"qq-z","imageAndVideoCount":"rq-z","imageAndVideoContainer":"sq-z","viewAllReviews":"tq-z"};